module.exports = __webpack_public_path__ + "static/media/3.5a388272.JPG";